// extracted by mini-css-extract-plugin
export default {"mainContent":"MainLayout_mainContent__RhKnW"};